import React from "react";
import "../../style/Oneday.css";
function Oneday() {
  const collection = [
    {
      userImage: "Rectangle 648.png",
      topName: "Art Blocks",
      petName: "Mutant warrior",
      crypto: "552.43 eth",
      rupees: "583K",
      percent: "+102%",
    },
    {
      userImage: "Rectangle 648 (1).png",
      topName: "Matrix Plus",
      petName: "Azuki",
      crypto: "552.43 eth",
      rupees: "583K",
      percent: "-45%",
    },
    {
      userImage: "Rectangle 648 (2).png",
      topName: "Goda mint",
      petName: "Doodles",
      crypto: "552",
      rupees: "583K",
      percent: "+102%",
    },
    {
      userImage: "Rectangle 648 (3).png",
      topName: "veefriends",
      petName: "Beanz Official",
      crypto: "552",
      rupees: "583K",
      percent: "-45%",
    },
    {
      userImage: "Rectangle 648 (4).png",
      topName: "Otherdeed",
      petName: "Town Star",
      crypto: "552",
      rupees: "583K",
      percent: "+102%",
    },
    {
      userImage: "Rectangle 648 (5).png",
      topName: "Art Blocks",
      petName: "Mutant warrior",
      crypto: "552",
      rupees: "583K",
      percent: "-45%",
    },
    {
      userImage: "Rectangle 648 (6).png",
      topName: "Matrix Plus",
      petName: "Azuki",
      crypto: "552",
      rupees: "583K",
      percent: "+102%",
    },
    {
      userImage: "Rectangle 648 (7).png",
      topName: "Goda mint",
      petName: "Doodles",
      crypto: "552",
      rupees: "583K",
      percent: "-45%",
    },
    {
      userImage: "Rectangle 648 (8).png",
      topName: "veefriends",
      petName: "Beanz Official",
      crypto: "552",
      rupees: "583K",
      percent: "+102%",
    },
    {
      userImage: "Rectangle 648 (9).png",
      topName: "Otherdeed",
      petName: "Town Star",
      crypto: "552",
      rupees: "583K",
      percent: "-45%",
    },
    {
      userImage: "Rectangle 648 (10).png",
      topName: "Art Blocks",
      petName: "Mutant warrior",
      crypto: "552",
      rupees: "583K",
      percent: "+102%",
    },
    {
      userImage: "Rectangle 648 (11).png",
      topName: "Matrix Plus",
      petName: "Azuki",
      crypto: "552",
      rupees: "583K",
      percent: "-45%",
    },
    {
      userImage: "Rectangle 648 (12).png",
      topName: "Goda mint",
      petName: "Doodles",
      crypto: "552",
      rupees: "583K",
      percent: "+102%",
    },
    {
      userImage: "Rectangle 648 (13).png",
      topName: "veefriends",
      petName: "Beanz Official",
      crypto: "552",
      rupees: "583K",
      percent: "-45%",
    },
    {
      userImage: "Rectangle 648 (14).png",
      topName: "Otherdeed",
      petName: "Town Star",
      crypto: "552",
      rupees: "583K",
      percent: "+102%",
    },
  ];

  return (
    <div className="check">
      {/* <div className="collectionPeople">
        <div>1</div>
        <div>
          <img src="Rectangle 648.png" alt="profile" />
        </div>
        <div>
          <div className="topName">Art Blocks</div>
          <div className="petName">
            Mutant warrior
            <img src="signed 1.png" alt="tick" className="tick ms-1" />
          </div>
        </div>
        <div>
          <div className="topName">552.43 eth</div>
          <div className="rupees">
            <div>$583K</div> <span>+102%</span>
          </div>
        </div>
      </div> */}
      {collection.map((e, i) => {
        return (
          <div className="collectionPeople" key={i}>
            <div className="d-flex align-items-center">
              <div className="number">{i + 1}</div>
              <div className="userImage">
                <img src={e.userImage} alt="profile" />
              </div>
              <div className="narginName">
                <div className="topName">{e.topName}</div>
                <div className="petName">
                  <div>{e.petName}</div>
                  <img src="signed 1.png" alt="tick" className="tick ms-1" />
                </div>
              </div>
            </div>
            <div>
              <div className="topName">552.43 eth</div>
              <div className="rupees">
                <div>${e.rupees}</div>{" "}
                <span
                  style={{
                    color: e.percent === "-45%" ? "#FF5D1C" : "#adff00",
                  }}
                >
                  {e.percent}
                </span>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default Oneday;
